import { render, staticRenderFns } from "./HostessTab.vue?vue&type=template&id=18569a7e&scoped=true"
import script from "./HostessTab.vue?vue&type=script&lang=js"
export * from "./HostessTab.vue?vue&type=script&lang=js"
import style0 from "./HostessTab.vue?vue&type=style&index=0&id=18569a7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18569a7e",
  null
  
)

export default component.exports